<template>
    <section :style="{ background: `url(${bg ? bg : ctasBg})` }"  class="call-to-action-section bg-primary bg-cover bg-center">
        <b-container>
            <b-row>
                <b-col class="text-center text-white">
                    <h1 class="text-white">{{ title }}</h1>
                    <p class="lead" v-html="desc"></p>
                   <div v-if="isHref">
                      <a
                         :href="link"
                         :target="target"
                         class="el-button text-uppercase bg-primary font-weight-bold el-button--primary is-round mt-3">
                         {{ textLink }}
                      </a>
                   </div>

                   <div v-else>
                      <router-link v-if="onLink" class="el-button text-uppercase bg-primary font-weight-bold el-button--primary is-round mt-3" :to="link">{{ textLink }}</router-link>
                   </div>

                   <button
                      v-if="searchLink"
                      @click="() => this.$router.push({name: 'search', params: { options: 'new' } })"
                      class="el-button text-uppercase bg-primary font-weight-bold el-button--primary is-round mt-4">
                      BUSCAR BICICLETA
                   </button>

                   <slot></slot>

                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>
import ctasBg from '@/assets/img/banner-home.jpg';
 export default {
    name: 'CallToActionSection',
     props: {
         title: String, background: null,
         desc: {
             type: String
         },
         onLink: {
             type: Boolean,
             default: true
         },
         link: {
             type: String
         },
         textLink: {
             type: String
         },
        searchLink: {
           type: Boolean,
           default: false
        },
        bg: {
           type: String
        },
        isHref: {
            type: Boolean,
            default: false
         },
        target: {
            type: String,
            default: '_self'
        }
     },
    mounted() {

    },
    data() {
    return {
        ctasBg
        }
    },
    methods: {

    },
    computed: {

    }
 };
</script>
